export default {
      id: "icon-branches-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-branches",
      toString: function () {
        return this.url;
      }
    }